export default function BubbleLogo({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id="bubz-logo-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FF75B5" />
          <stop offset=".5" stopColor="#70C1FF" />
          <stop offset="1" stopColor="#FFD034" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="26" fill="#DDF1FF" stroke="url(#bubz-logo-g)" strokeWidth="5" />
      <path d="M17 23a17 17 0 0 1 9-9" stroke="#fff" strokeWidth="4.5" strokeLinecap="round" fill="none" />
      <circle cx="25" cy="32" r="3.4" fill="#1E293B" />
      <circle cx="39" cy="32" r="3.4" fill="#1E293B" />
      <path d="M24 40q8 7 16 0" stroke="#1E293B" strokeWidth="3.6" fill="none" strokeLinecap="round" />
    </svg>
  );
}
